// extracted by mini-css-extract-plugin
module.exports = {"chart-container":"InsiderTradesAndPerformance_chart-container__JLaZU"};